module.exports = __webpack_public_path__ + "static/dashboard_donate_bg@2x-58ba5eb83cf0e324e6ce4e103869f006.png";